module.exports = __webpack_public_path__ + "img/HomepageBannerBackgroundHeaderDesktop.2b015fdc.png";